import React from "react";
import { Box, Divider, Paper, Typography } from "@mui/material";
import { TextFieldCust, SelectCust, ButtonCust } from "../../../widgets";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import {
  numberAlphabetPattern,
  PhoneNoPattern,
} from "../../../../utils/regexPatterns";
import {
  displayPhoneNumberFormat,
  gtmTagManager,
} from "../../../../utils/commonFunctions";
import EnvConfig from "../../../../config/env.config.json";
import { BrandNameUpdate } from "../../../../utils/commonFunctions/BrandNameUpdate";
import { gaEvents, gaScreenNames } from "../../../../Types/GoogleAnalytics";
type Props = {
  formik: any;
  content: any;
  operators: any;
  currentOperator: any;
  btnLoader: boolean;
  handleChangeCarrier: any;
  styles: any;
};

const CurrentNumberForm = (props: Props) => {
  const {
    formik,
    content,
    operators,
    currentOperator,
    btnLoader,
    handleChangeCarrier,
    styles,
  } = props;
  const { c_num } = content;

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        background: "var(--lightgrey)",
      }}
    >
      {/* <ArrowBackIosIcon
            sx={{ ml: { md: "30px", sm: "25px", xs: "25px" } }}
            // className={
            //   disableBack
            //     ? clsx(styles.disable_icon, styles.arrow_icon)
            //     : styles.arrow_icon
            // }
            // onClick={() => (disableBack ? null : handleStep(false))}
          /> */}
      <Paper
        sx={{
          // border: "1px solid rgba(0,0,0,.2)",
          width: { xs: "92%", sm: "724px" },
          // height: "600px",
          mt: { xs: "40px", sm: "60px" },
          boxShadow: { xs: "unset !important" },
          // px: { xs: "30px" },
          // marginBottom:"100px"
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            p: { xs: "25px 0px" },
            gap: "10px",
          }}
        >
          {/* <Box
            component="img"
            alt={"circular_loader"}
            src={content?.carrier_info_icon?.data?.attributes?.url}
            sx={{ width: { xs: "33px" }, pr: { md: "16px" } }}
          /> */}
          <Typography
            sx={{
              fontSize: { xs: "18px", sm: "24px" },
              fontFamily: "var(--font_family_Bold)",
              textAlign: "center",
              fontWeight: "var(--font_weight_4)",
              color: "var(--black)",
              lineHeight: { xs: "30px", sm: "36px" },
            }}
          >
            {c_num?.sub_title}
          </Typography>
        </Box>
        <Box sx={{ width: "100%", textAlign: "center" }}>
          <Divider style={{ border: "1px solid var(--lightgrey_6)" }}></Divider>
        </Box>
        <Box sx={{ textAlign: "center" }}>
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: "var(--font_weight_2)",
              lineHeight: "26px",
              fontFamily: "var(--font_family_Semibold)",
              my: { xs: "12px", sm: "25px" },
              color: "var(--text_color)",
            }}
          >
            {content?.step_txt}
          </Typography>
        </Box>
        <Box
          display="flex"
          flexWrap="wrap"
          sx={{ pl: { xs: "0", sm: "20px" } }}
        >
          <Box
            width={{ xs: "100%", sm: "80%", md: "45%" }}
            sx={{ px: { xs: "12px" } }}
          >
            <TextFieldCust
              name="phoneNumber"
              type="text"
              value={displayPhoneNumberFormat(formik.values.phoneNumber)}
              label={c_num?.ph_num_ph}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                const { value } = e.target;
                if (
                  (PhoneNoPattern.test(value) && Number(value) >= 0) ||
                  value === ""
                ) {
                  formik.handleChange(e);
                }
                if (value.length > 10) {
                  const contactNumber: string = String(
                    value.match(/\d/g)?.join("") || ""
                  );
                  e.target.value = contactNumber;
                  formik.handleChange(e);
                }
              }}
              maxLength={10}
              sx={{ my: "6px" }}
              error={
                formik.touched?.phoneNumber && formik.errors?.phoneNumber
                  ? true
                  : false
              }
              helperText={
                formik.touched?.phoneNumber && formik.errors?.phoneNumber
              }
            />
            <Box display="flex" justifyContent="end">
              <Typography
                sx={{
                  fontSize: "12px",
                  fontFamily: "var(--font_family_Regular)",
                }}
              >
                {formik.values?.phoneNumber?.length}/10
              </Typography>
            </Box>
          </Box>
          <Box
            width={{ xs: "100%", sm: "80%", md: "45%" }}
            sx={{ px: { xs: "12px" }, mb: { xs: "10px", md: "unset" } }}
          >
            {operators && (
              <SelectCust
                value={formik.values.carrier}
                options={operators}
                name="carrier"
                isLabel={true}
                placeholder={c_num?.carrier_ph}
                onChange={handleChangeCarrier}
                helperText={formik.touched?.carrier && formik.errors?.carrier}
                error={
                  formik.touched?.carrier && formik.errors?.carrier
                    ? true
                    : false
                }
                formStyles={{ my: "6px" }}
              />
            )}
            {EnvConfig.SHOW_ACT_OTHER_CARRIER &&
              currentOperator?.label === "Others" && (
                <TextFieldCust
                  name="otherCarrier"
                  type="text"
                  placeholder={c_num?.enter_carrier}
                  value={formik.values.otherCarrier}
                  label={c_num?.carr_ph}
                  sx={{ my: "6px" }}
                  maxLength={10}
                  helperText={
                    formik.touched?.otherCarrier && formik.errors?.otherCarrier
                  }
                  onChange={handleChangeCarrier}
                />
              )}
          </Box>
          <Box
            width={{ xs: "100%", sm: "80%", md: "45%" }}
            sx={{ px: { xs: "12px" } }}
          >
            <TextFieldCust
              name="zip"
              type="text"
              value={formik.values.zip}
              label={c_num?.zip_ph}
              onChange={(e) => {
                if (
                  PhoneNoPattern.test(e.target.value) ||
                  e.target.value === ""
                ) {
                  formik.handleChange(e);
                }
              }}
              sx={{ my: "6px" }}
              maxLength={5}
              error={formik.touched?.zip && formik.errors?.zip ? true : false}
              helperText={formik.touched?.zip && formik.errors?.zip}
            />
            <Box display="flex" justifyContent="end">
              <Typography
                sx={{
                  fontSize: "12px",
                  fontFamily: "var(--font_family_Regular)",
                }}
              >
                {formik.values?.zip?.length}/5
              </Typography>
            </Box>
          </Box>
          <Box
            width={{ xs: "100%", sm: "80%", md: "45%" }}
            sx={{ px: { xs: "12px" }, mb: { xs: "10px", md: "unset" } }}
          >
            <TextFieldCust
              name="accNumber"
              type="text"
              value={formik.values.accNumber}
              label={
                formik.values.carrier && !content?.msgs?.hide_carrier_info
                  ? `${formik.values.carrier} ${c_num?.acc_num_ph}`
                  : `${c_num?.cur_txt} ${c_num?.acc_num_ph}`
              }
              onChange={(e) => {
                if (
                  numberAlphabetPattern.test(e.target.value) ||
                  e.target.value === ""
                ) {
                  formik.handleChange(e);
                }
              }}
              sx={{ my: "6px" }}
              maxLength={20}
              error={
                formik.touched?.accNumber && formik.errors?.accNumber
                  ? true
                  : false
              }
              helperText={formik.touched?.accNumber && formik.errors?.accNumber}
            />
          </Box>
          <Box
            width={{ xs: "100%", sm: "80%", md: "45%" }}
            sx={{ px: { xs: "12px" } }}
          >
            <TextFieldCust
              name="password"
              type="text"
              value={formik.values.password}
              label={
                formik.values.carrier && !content?.msgs?.hide_carrier_info
                  ? `${formik.values.carrier} ${c_num?.pin_ph}`
                  : !content?.msgs?.hide_carrier_info
                  ? `${c_num?.cur_txt} ${c_num?.pin_ph}`
                  : `${c_num?.pin_ph}`
              }
              onChange={(e) => {
                if (
                  numberAlphabetPattern.test(e.target.value) ||
                  e.target.value === ""
                ) {
                  formik.handleChange(e);
                }
              }}
              sx={{ my: "6px" }}
              maxLength={15}
              error={
                formik.touched?.password && formik.errors?.password
                  ? true
                  : false
              }
              helperText={formik.touched?.password && formik.errors?.password}
            />
            {currentOperator?.pinLabel && (
              <Typography className={styles.pin_label} sx={{ mt: "10px" }}>
                {currentOperator.pinLabel}
              </Typography>
            )}
          </Box>
        </Box>
        <Box sx={{ textAlign: "center", mt: "25px", mb: "35px" }}>
          <ButtonCust
            variantType={EnvConfig.PRIMARY_BUTTON_TYPE}
            sx={{
              width: { xs: "250px", sm: "250px", md: "250px" },
              // height: { md: "50px !important" },
            }}
            onClick={() => {
              formik.handleSubmit();
              gtmTagManager({
                event: gaEvents?.portInDetailSubmit,
                screen_name: gaScreenNames?.activation,
                existing_carrier: formik?.values?.carrier,
              });
            }}
            loading={btnLoader}
          >
            {c_num?.next_btn}
          </ButtonCust>
        </Box>
      </Paper>
    </Box>
    // <Box className={styles.form_container}>
    //   <Typography className={styles.form_title}>{c_num?.sub_title}</Typography>
    //   <Typography
    //     width={{ xs: "100%", sm: "80%", md: "50%" }}
    //     className={styles.form_description}
    //   >
    //     {BrandNameUpdate(c_num?.desc)}
    //   </Typography>
    //   <Box width={{ xs: "100%", sm: "80%", md: "65%" }}>
    //     <TextFieldCust
    //       name="phoneNumber"
    //       type="text"
    //       value={displayPhoneNumberFormat(formik.values.phoneNumber)}
    //       label={c_num?.ph_num_ph}
    //       onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
    //         const { value } = e.target;
    //         if (
    //           (PhoneNoPattern.test(value) && Number(value) >= 0) ||
    //           value === ""
    //         ) {
    //           formik.handleChange(e);
    //         }
    //         if (value.length > 10) {
    //           const contactNumber: string = String(
    //             value.match(/\d/g)?.join("") || ""
    //           );
    //           e.target.value = contactNumber;
    //           formik.handleChange(e);
    //         }
    //       }}
    //       maxLength={10}
    //       sx={{ my: "10px" }}
    //       error={
    //         formik.touched?.phoneNumber && formik.errors?.phoneNumber
    //           ? true
    //           : false
    //       }
    //       helperText={formik.touched?.phoneNumber && formik.errors?.phoneNumber}
    //     />
    //     {operators && (
    //       <SelectCust
    //         value={formik.values.carrier}
    //         options={operators}
    //         name="carrier"
    //         placeholder={c_num?.carrier_ph}
    //         onChange={handleChangeCarrier}
    //         helperText={formik.touched?.carrier && formik.errors?.carrier}
    //         error={
    //           formik.touched?.carrier && formik.errors?.carrier ? true : false
    //         }
    //         formStyles={{ my: "10px" }}
    //       />
    //     )}
    //     {EnvConfig.SHOW_ACT_OTHER_CARRIER &&
    //       currentOperator?.label === "Others" && (
    //         <TextFieldCust
    //           name="otherCarrier"
    //           type="text"
    //           placeholder={c_num?.enter_carrier}
    //           value={formik.values.otherCarrier}
    //           label={c_num?.carr_ph}
    //           sx={{ my: "10px" }}
    //           maxLength={10}
    //           helperText={
    //             formik.touched?.otherCarrier && formik.errors?.otherCarrier
    //           }
    //           onChange={handleChangeCarrier}
    //         />
    //       )}
    //     <TextFieldCust
    //       name="zip"
    //       type="text"
    //       value={formik.values.zip}
    //       label={c_num?.zip_ph}
    //       onChange={(e) => {
    //         if (PhoneNoPattern.test(e.target.value) || e.target.value === "") {
    //           formik.handleChange(e);
    //         }
    //       }}
    //       sx={{ my: "10px" }}
    //       maxLength={5}
    //       error={formik.touched?.zip && formik.errors?.zip ? true : false}
    //       helperText={formik.touched?.zip && formik.errors?.zip}
    //     />
    //     <Typography className={styles.limit_text}>
    //       {formik.values?.zip?.length}/5
    //     </Typography>
    //     <TextFieldCust
    //       name="accNumber"
    //       type="text"
    //       value={formik.values.accNumber}
    //       label={
    //         formik.values.carrier
    //           ? `${formik.values.carrier} ${c_num?.acc_num_ph}`
    //           : `${c_num?.cur_txt} ${c_num?.acc_num_ph}`
    //       }
    //       onChange={(e) => {
    //         if (
    //           numberAlphabetPattern.test(e.target.value) ||
    //           e.target.value === ""
    //         ) {
    //           formik.handleChange(e);
    //         }
    //       }}
    //       sx={{ my: "10px" }}
    //       maxLength={20}
    //       error={
    //         formik.touched?.accNumber && formik.errors?.accNumber ? true : false
    //       }
    //       helperText={formik.touched?.accNumber && formik.errors?.accNumber}
    //     />
    //     <TextFieldCust
    //       name="password"
    //       type="text"
    //       value={formik.values.password}
    //       label={
    //         formik.values.carrier
    //           ? `${formik.values.carrier} ${c_num?.pin_ph}`
    //           : `${c_num?.cur_txt} ${c_num?.pin_ph}`
    //       }
    //       onChange={(e) => {
    //         if (
    //           numberAlphabetPattern.test(e.target.value) ||
    //           e.target.value === ""
    //         ) {
    //           formik.handleChange(e);
    //         }
    //       }}
    //       sx={{ my: "10px" }}
    //       maxLength={15}
    //       error={
    //         formik.touched?.password && formik.errors?.password ? true : false
    //       }
    //       helperText={formik.touched?.password && formik.errors?.password}
    //     />
    //     {currentOperator?.pinLabel && (
    //       <Typography className={styles.pin_label}>
    //         {currentOperator.pinLabel}
    //       </Typography>
    //     )}
    //   </Box>
    //   <ButtonCust
    //     variantType={EnvConfig.PRIMARY_BUTTON_TYPE}
    //     sx={{ width: "220px", mt: "20px" }}
    //     onClick={() => {
    //       formik.handleSubmit();
    //     }}
    //     loading={btnLoader}
    //   >
    //     {c_num?.next_btn}
    //   </ButtonCust>
    // </Box>
  );
};
export default CurrentNumberForm;
